var exports = {
  "x6": "x4ddf2309--d47c86--button",
  "j": "x4ddf2309--d47c86--button-text",
  "Qs": "x4ddf2309--d47c86--content",
};

module.exports = exports;
